export const environment = {
  production: false,
  application:
    {
      name: 'Quaderni ri-creativi Rambaldi',
      version: '1.0',
    },

  frontendEndpoint: 'http://localhost:4200/',
  apiUrl: 'https://www.quaderniricreativi.it/rambaldi/'
};
